import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Provider } from 'react-redux';
import { store } from './redux/store';
// import { WalletContextProvider } from './utilities/WalletProvider';
// components
import NavBar from './components/navbar';
// import Sidebar from './components/sidebar';
// import Header from './components/header';
import ToastGeneral from './components/toast';
import Loading from './components/loading';

// aos_-_css
import './styles/aos.css';

// pages
// import WebPage from './pages/webpage';
// import AuthPage from './pages/auth/authpage';
import Home from './pages/home';
// import Evalys from './pages/eva';
// import Wellness from './pages/ai-audit';
// import Insights from './pages/staking';
// import Connect from './pages/rug-checker';
// import Profile from './pages/wallet-analyzer';
// import RightBar from './components/rightbar';


// styles
import './styles/main.css'
import './styles/auth.css'
import './styles/sidebar.css'
import './styles/rightbar.css'
import './styles/flex-system.css'
import './styles/grid-system.css'
import './styles/text.css'
import './styles/spacing.css'
import './styles/responsive.css'
import './styles/effect.css'
import './styles/moodring.css'
import './styles/wellness-score.css'


// custom_-_js_-_files
import './scripts/main';
import { SolanaWalletProvider } from './components/SolanaWalletProvider';
// import Cart from './pages/cart';
// import FullPage from './pages/demovortex';
// import Ring from './pages/ring';

function App() {

  
  return (
    <Provider store={store}>

      {/* <WalletContextProvider> */}
          
        <BrowserRouter>

        <SolanaWalletProvider>
          {/* <div className="tech-container flex row"> */}

            <NavBar />

            <Loading />

            <ToastGeneral />

            {/* <Sidebar /> */}

            {/* <div className="main-screen"> */}
              {/* <Header /> */}

              <Routes>

                <Route 
                  index
                  element={<Home />}
                />
                {/* <Route 
                  path='/eva'
                  element={<Evalys />}
                /> */}
                {/* <Route 
                  path='/shop'
                  element={<Cart />}
                /> */}

                {/* <Route 
                  index
                  element={<WebPage />}
                /> */}

                {/* <Route 
                  path='/ring'
                  element={<Ring />}
                /> */}

                {/* <Route 
                  path='/account-data-deletion'
                  element={<AccountManagement />}
                />

                <Route 
                  path='/privacy-policy'
                  element={<PrivacyPolicy />}
                /> */}
                
                {/* auths */}
                {/* <Route 
                  path='/auth'
                  element={<AuthPage />}
                /> */}
                {/* <Route 
                  index
                  path='/signin'
                  element={<SignIn />}
                />
                <Route 
                  path='/signup'
                  element={<SignUp />}
                /> */}
                {/* auths */}

                {/* <Route 
                  path='/dashboard'
                  element={<Home />}
                />

                <Route 
                  path='/ai-audit'
                  element={<Wellness />}
                />
                <Route 
                  path='/staking'
                  element={<Insights />}
                />
                <Route 
                  path='/rug-checker'
                  element={<Connect />}
                />
                <Route 
                  path='/wallet-analyzer'
                  element={<Profile />}
                /> */}
                

              </Routes>
            {/* </div> */}

            {/* <RightBar /> */}

          {/* </div> */}
        </SolanaWalletProvider>

      </BrowserRouter>

    {/* </WalletContextProvider> */}

  </Provider>
  );
}

export default App;
